module.exports = __webpack_public_path__ + "img/right-frame-mobile.9fa5c8fb.svg";